export const CONTABILIDAD = {
    URL: 'Services/StarAccounting/',
    URL_ACCOUTING: 'Services/Accounting/',
    GetInvoiceByIdWithDetails: 'Services/Invoicing/SalesInvoicesService.svc/GetInvoiceByIdWithDetails',
    HOME: {
        HasFilesPendingOfProcess: 'AccountingExportService.svc/HasFilesPendingOfProcess',
        GetAccountingHistory: 'HomeService.svc/GetAccountingHistory',
        GetDocumentsPendingOfExport: 'HomeService.svc/GetDocumentsPendingOfExport',
        GetLatestExportedDocuments: 'HomeService.svc/GetLatestExportedDocuments'
    },
    EXPORTACION: {
        FindExportableDocumentsAll: 'DocumentExportingService.svc/FindExportableDocumentsAll',
        FindExportableDocumentsPaged: 'DocumentExportingService.svc/FindExportableDocumentsPaged',
        FindExportableDocuments: 'DocumentExportingService.svc/FindExportableDocuments',
        ExportDocuments: 'DocumentExportingService.svc/ExportDocuments',
    },
    CONFIGURACION: {
        FindAccountingConfigurations: 'ConfigurationService.svc/FindAccountingConfigurations',
        GetConfiguration: 'ConfigurationService.svc/GetConfiguration',
        GetSupportedExporters: 'ConfigurationService.svc/GetSupportedExporters',
        GetAvailableTemplates: 'ConfigurationService.svc/GetAvailableTemplates',
        AddConfiguration: 'ConfigurationService.svc/AddConfiguration',
        UpdateConfiguration: 'ConfigurationService.svc/UpdateConfiguration',
        UpdateTemplateDetail: 'ConfigurationService.svc/UpdateTemplateDetail',
        CopyConfiguration: 'ConfigurationService.svc/CopyConfiguration',
        DeleteConfiguration: 'ConfigurationService.svc/DeleteConfiguration',
        GetWharehouseList: 'ConfigurationService.svc/GetWharehouseList',
        GetAccountingCompanies: 'ConfigurationService.svc/GetAccountingCompanies',
        GetAccountingModes: 'ConfigurationService.svc/GetAccountingModes',
        GetUnlockedLedgerTypes: 'ConfigurationService.svc/GetUnlockedLedgerTypes',
        UpdateTemplateHeaderSetLedgerId: 'ConfigurationService.svc/UpdateTemplateHeaderSetLedgerId'
    }
}
